export default "__VITE_ASSET__CSXN8QDj__"